import type { TOC } from '@ember/component/template-only';
import { PrismBadge } from '@mylighthouse/prism-ember';
import type { BadgeType } from '@mylighthouse/prism-ember/types/components/prism/badge';

interface TransactionCellsTdStatusSignature {
  Args: {
    value: {
      badgeType: BadgeType;
      formattedStatus: string;
    };
  };
}

const TransactionCellsTdStatus = <template>
  <PrismBadge
    @badgeType={{@value.badgeType}}
    @label={{@value.formattedStatus}}
  />
</template> satisfies TOC<TransactionCellsTdStatusSignature>;

export default TransactionCellsTdStatus;
